export const MMC_ComponentSlides = require('./mcc-component-driven-design')
  .default;
export const SCS_ComponentSlides = require('./scs-state-react-styling').default;
export const DS_GS_ComponentSlides = require('./ds-getting-specific').default;
export const CS_ComponentSlides = require('./cs-breaking-global-namespace').default;

export default {
  MMC_ComponentSlides,
  SCS_ComponentSlides,
  DS_GS_ComponentSlides,
  CS_ComponentSlides,
};



// WEBPACK FOOTER //
// ./src/presentations/state-of-styling/index.js